import { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faBullhorn, faCheck, faList, faTrademark, faInbox } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

export default function Home() {
  const [Report, setReport] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();
console.log("messages",messages)
  const fetchReport = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("tokencc",token)
      const response = await fetch(`${baseUrl}/reports/stats`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
console.log("response",response)
if(response.status == '401'){
  navigate(`/login`);

}
      if (response.ok) {
        const data = await response.json();
        setReport(data);
      } else {
        toast.error('Failed to fetch report data.');
      }
    } catch (err) {
      console.log("err",err)
      setError('Failed to fetch report data.');
    } finally {
      setLoading(false);
    }
  };

  const fetchMessages = async () => {
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/contact-us`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setMessages(data.contacts || []);
      } else {
        toast.error('Failed to fetch messages.');
      }
    } catch (err) {
      toast.error('Failed to fetch messages.');
    }
  };

  useEffect(() => {
    fetchReport();
    fetchMessages();
  }, []);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <h2 style={{ textAlign: 'center', marginBottom: '20px',color:"#000" }}>Report Overview</h2>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'row', 
        gap: '20px', 
        justifyContent: 'space-between', 
        overflowX: 'auto' 
      }}>
        <StatCard icon={faUsers} label="Total Users" value={Report.totalUsers} />
        <StatCard icon={faBullhorn} label="Total Ads" value={Report.totalAds} />
        <StatCard icon={faCheck} label="Approved Ads" value={Report.totalApprovedAds} />
        <StatCard icon={faList} label="Categories" value={Report.totalCategories} />
        <StatCard icon={faTrademark} label="Brands" value={Report.totalBrands} />
        <StatCard icon={faInbox} label="Messages" value={Report.totalMessages} />
      </div>

      <h3 style={{ textAlign: 'center', marginTop: '40px', marginBottom: '20px',color:"#000" }}>Received Messages</h3>
      <div style={{
        maxHeight: '300px',
        overflowY: 'auto',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '10px',
        backgroundColor: '#f9f9f9',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      }}>
        {messages.length > 0 ? (
          messages.map((msg) => (
            <div key={msg.id} style={{
              marginBottom: '15px',
              borderBottom: '1px solid #ddd',
              paddingBottom: '10px',
            }}>
              <p style={{ margin: '5px 0', fontWeight: 'bold', color: '#333' }}>{msg.name}</p>
              <p style={{ margin: '5px 0', color: '#555' }}>
                <strong>Phone:</strong> {msg.phone_number}
              </p>
              <p style={{ margin: '5px 0', color: '#555' }}>
        <strong>Email:</strong>{' '}
        <a href={`mailto:${msg.email}`} style={{ color: '#0066cc' }}>
          {msg.email}
        </a>
      </p>

              
              <p style={{ margin: '5px 0', color: '#555' }}>
                <strong>Message:</strong> {msg.message}
              </p>
              <p style={{ margin: '5px 0', fontSize: '12px', color: '#999' }}>
                <strong>Received At:</strong> {new Date(msg.created_at).toLocaleString()}
              </p>
            </div>
          ))
        ) : (
          <p style={{ textAlign: 'center', color: '#999' }}>No messages available.</p>
        )}
      </div>
    </div>
  );
}

function StatCard({ icon, label, value }) {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      backgroundColor: '#f9f9f9', 
      border: '1px solid #e0e0e0', 
      borderRadius: '8px', 
      padding: '15px', 
      textAlign: 'center', 
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', 
      minWidth: '150px' 
    }}>
      <FontAwesomeIcon 
        icon={icon} 
        style={{ fontSize: '24px', color: '#4caf50', marginBottom: '10px' }} 
      />
      <div>
        <h3 style={{ fontSize: '24px', margin: '0', color: '#333' }}>{value}</h3>
        <p style={{ fontSize: '14px', margin: '5px 0 0', color: '#777' }}>{label}</p>
      </div>
    </div>
  );
}
